<!-- Spacer -->
<div
    [ngClass]="item.classes?.wrapper"
    class="fuse-horizontal-navigation-item-wrapper"
></div>
